import React from 'react';
import { Col, Row, Spinner } from 'reactstrap';

const Loader = (props) => (
  <Row className="flex-center py-5">
    <Col xs="auto">
      <Spinner {...props} children="" />
    </Col>
  </Row>
);

Loader.propTypes = { ...Spinner.propTypes };

Loader.defaultProps = {
  type: 'grow',
  size: 'sm',
  color: 'primary',
};

export default Loader;
